import React, { useState } from 'react';
import { DollarSign, Clock } from 'lucide-react';
import TabPageLayout from 'modules/swiftboard/components/TabPageLayout';
import Currency from './currency/Currency';
import Timezone from './timezone/Timezone';
import useUrlTab from "modules/swiftboard/components/useUrlTab";

const SystemDirectory = () => {

  const [activeTab, setActiveTab] = useUrlTab(["currency", "timezone"]);
  const [tabCounts, setTabCounts] = useState({});

  const setTabCount = (tabId) => {
    return (count) => {
      setTabCounts((prev) =>
        prev[tabId] === count
          ? prev
          : { ...prev, [tabId]: count }
      );
    };
  };

  const systemDirectoryTabs = [
    {
      id: 1,
      label: 'Currency',
      icon: <DollarSign size={18} />,
    },
    {
      id: 2,
      label: 'Timezone',
      icon: <Clock size={18} />,
    },
  ].map((tab, index) => ({
    ...tab,
    badge:
      index === activeTab && tabCounts[tab.id] !== undefined
        ? { count: tabCounts[tab.id], compact: true }
        : undefined,
  }));


  const handleTabChange = (index, tab) => {
    setActiveTab(index);
  };

  return (
    <TabPageLayout
      tabs={systemDirectoryTabs}
      activeTab={activeTab}
      onTabChange={handleTabChange}
    >
      {activeTab === 0 && <Currency onTotalCountChange={setTabCount(1)} />}
      {activeTab === 1 && <Timezone onTotalCountChange={setTabCount(2)} />}
    </TabPageLayout>
  );
};

export default SystemDirectory;
